import { Modal } from "@maysoft/common-component-react"
import { useEffect, useState } from "react"
import TemplateConfigForm from "../container/casecodeConfig"
import Strings from "constants/strings"
import { SettingProps } from "./simpleConfigModal"
import BasicInfoSection from "../container/baseInfo"

type Item = {
    id: string
    key: string
    value: string
}

type ConfigType = {
    notification: Item[]
    email: Item[]
    sms: Item[]
}

const TemplateConfigPopup = ({
    serviceName,
    tenantName,
    visibled,
    value,
    onClose,
    onSubmit
}: SettingProps) => {

    const [config, setConfig] = useState<ConfigType>({
        notification: [],
        email: [],
        sms: []
    })

    useEffect(() => {
        try {
            const parsed = JSON.parse(value)

            const mapToArray = (obj: Record<string, string>) =>
                Object.entries(obj || {}).map(([k, v]) => ({
                    id: `${Date.now()}_${Math.random()}`,
                    key: k,
                    value: v
                }))

            setConfig({
                notification: mapToArray(parsed.notification),
                email: mapToArray(parsed.email),
                sms: mapToArray(parsed.sms)
            })
        } catch {
            console.error("Invalid JSON")
        }
    }, [value])

    const toObject = (arr: Item[]) =>
        arr.reduce((acc, item) => {
            if (!item.key) return acc
            acc[item.key] = item.value
            return acc
        }, {} as Record<string, string>)

    const handleSubmit = () => {
        const result = {
            notification: toObject(config.notification),
            email: toObject(config.email),
            sms: toObject(config.sms)
        }

        onSubmit(JSON.stringify(result))
    }

    return (
        <Modal
            visible={visibled}
            maxWidth="md"
            fullWidth
            title="Template Configuration"
            buttonAction={Strings.Common.SAVE}
            onClose={onClose}
            onAction={handleSubmit}
            hasActionButton
        >
            <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />
            <TemplateConfigForm
                value={config}
                onChange={setConfig}
            />
        </Modal>
    )
}

export default TemplateConfigPopup